<template>
    <SecondaryPage>
        <div class="max-w-sm m-auto py-6 px-4">
            <div class="font-bold text-center text-24 text-a-brown-502314 mb-6">{{lbl.login.guest}}</div>
            <InputContactNumber
                    v-model:inputValue="contactNumber"
                    :maxLength="12"
                    :minLength="12"
                    delimeter="-"
                    :errorInfo="errorInfo[0]"
                    :isShowError="false"
                    :isSubmitted="false"
                    :inputLbl="lbl.login.phoneNoRequire"
                    @update:inputValue="onFormChange()"
            ></InputContactNumber>
            <InputText
                    v-model:inputValue="name"
                    :isTextOnly="true"
                    :errorInfo="errorInfo[1]"
                    :isShowError="false"
                    :isSubmitted="false"
                    :inputLbl="lbl.login.name"
                    @update:inputValue="onFormChange()"
            ></InputText>
            <Checkbox v-model:check="checkTerms1" @update:check="onFormChange()">
                <div class="text-14 text-a-brown-502314">
                    {{lbl.login.read_accept}}
                    <span class="text-a-red-d62300 underline font-bold cursor-pointer" @click="clickTerm()">{{lbl.login.term}}</span>
                    {{lbl.login.and}}
                    <span class="text-a-red-d62300 underline font-bold cursor-pointer" @click="clickPrivacy()">{{lbl.login.privacy}}</span>
                    {{lbl.login.of_burgerking}}
                </div>
            </Checkbox>
            <Checkbox v-model:check="checkTerms2">
                <div class="text-14 text-a-brown-502314" v-if="localeCode==1033">
                    {{lbl.login.i_agree}}
                    <span class="text-a-red-d62300 underline font-bold" @click="clickMKT()">{{lbl.login.affiliated_companies}}</span>
                    {{lbl.login.learn_more}}
                    <span class="text-a-red-d62300 underline font-bold cursor-pointer" @click="clickPrivacy()">{{lbl.login.privacy_policy}}</span>
                    {{lbl.login.form_company}}
                </div>
                <div class="text-14 text-a-brown-502314" v-else>
                    {{lbl.login.i_interest}}
                    <span class="text-a-red-d62300 underline font-bold cursor-pointer" @click="clickMKT()">{{lbl.login.affiliated_companies}}</span>
                </div>
            </Checkbox>

            <RedButton v-if="formValid" class="mt-8" @click="clickSubmit()">
                <div class="text-16">{{lbl.login.submit}}</div>
            </RedButton>
            <DisableBtn v-else class="mt-8">
                <div class="text-16">{{lbl.login.submit}}</div>
            </DisableBtn>
        </div>
    </SecondaryPage>
</template>
<script>
import Util from '@/helper/Utility.js';
import { FormHelper } from '@/helper/FormHelper';
import CacheHelper from '@/helper/CacheHelper.js';
import { CacheKey } from '@/helper/StaticValue.js';
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue'
import InputText from '@/components/Input/label/InputText.vue';
import Checkbox from '@/components/Input/simple/Checkbox.vue';
import RedButton from '@/components/Button/RedButton.vue';
import DisableBtn from '@/components/Button/DisableBtn.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//service
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA';
import LoginGuestApi from '../service/LoginGuestApi.js';
import { GuestLoginModelBuilder } from '../model/GuestLoginModel.js';

export default {
    mixins: [LocaleMixin, ModalMixin, AuthStatusMixin],
    components: {
        SecondaryPage,
        InputContactNumber,
        InputText,
        Checkbox,
        RedButton,
        DisableBtn,
    },
    data: function () {
        return {
            pathAfterLogin: null,

            contactNumber: '',
            name: '',

            checkTerms1: false,
            checkTerms2: false,
            pdpaVersion: {
                terms: 1,
                privacy: 1,
                market: 1,
            },

            formValid: false,
            errorInfo: FormHelper.genErrorInfo(2),
        };
    },
    created: function () {
        this.getPdpaVersion();

        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }
    },
    // mounted: function () {
    //     this.modal.confirmGuestLoginModal.show();
    // },
    methods: {
        getPdpaVersion: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe({
                next: (data) => {
                    // console.log('pdpa', data);
                    this.pdpaVersion.terms = data?.terms?.current_version ?? 1;
                    this.pdpaVersion.privacy = data?.privacy?.current_version ?? 1;
                    this.pdpaVersion.market = data?.marketingOption?.current_version ?? 1;

                    Util.log('pdpa', this.pdpaVersion);
                },
                error: (err) => {
                    console.log('pdpa', err);
                },
            })
        },

        clickSubmit: async function () {
            if (this.validateForm()) {
                this.tracking.event('register','click_submit_guest_login', null, null);
                console.log('pass');
                let rs = await this.apiCheckGuestNeedLogin();

                if (rs) {
                    // go login
                    this.modal.confirmGuestLoginModal
                        .setContactNumber(this.contactNumber)
                        .show();
                    this.modal.confirmGuestLoginModal.onClickLogin(() => {
                        this.openLogin();
                    });
                    this.modal.confirmGuestLoginModal.onClickGuest(() => {
                        //this.afterLoginRedirect();
                        this.updateGuestProfile();
                    
                    });
                } else {
                    // update profile
                    this.updateGuestProfile();
                }
            }
        },
        onFormChange: function () {
            this.validateForm();
        },
        validateForm: function () {
            this.formValid = FormHelper.validate(this.errorInfo) && this.checkTerms1;
            return this.formValid;
        },
        openLogin: function () {
            let loginData = {
                username: this.contactNumber,
            };
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.loginUsername, loginData);

            this.$router.push('/login/password');
        },

        apiCheckGuestNeedLogin: function () {
            return new Promise((resolve) => {
                LoginGuestApi.checkGuestHasPin(this.contactNumber).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        console.log(err);
                        // this.errorApi(err);
                    },
                });
            });
        },

        updateGuestProfile: async function () {
            let guestParams = new GuestLoginModelBuilder()
                .setContactNumber(this.contactNumber)
                .setName(this.name)
                .setTerms(this.pdpaVersion.terms)
                .setPrivacy(this.pdpaVersion.privacy)
                .setMarket(this.pdpaVersion.market)
                .create()
                .getParams();

            this.modal.loadingModal.show();
            let rs = await this.apiUpdateGuestProfile(guestParams);

            if (!rs) {
                this.modal.loadingModal.hide();
                return;
            }

            await this.apiUpdateProfile()
            this.modal.loadingModal.hide();
            this.afterLoginRedirect();
            // this.$router.replace('/home');
        },
        apiUpdateGuestProfile: function (guestParams) {
            return new Promise((resolve) => {
                LoginGuestApi.updateGuestProfile(guestParams).subscribe({
                    next: (data) => {
                        resolve(true);
                        console.log(data);
                    },
                    error: (err) => {
                        resolve(false);
                        console.log(err);
                        this.errorApi(err);
                    },
                });
            });
        },

        afterLoginRedirect: function () {
            if (this.pathAfterLogin == null) {
                this.$router.replace('/home');
            } else {
                this.$router.replace(this.pathAfterLogin);
            }
        },
        clickTerm: function () {
            this.$router.push("/terms");
        },
        clickPrivacy: function () {
            this.$router.push("/privacy");
        },
        clickMKT: function () {
            window.location.href = "https://www.minorfood.com/th/privacy/companies";
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
